export const TOUCH_DRAG_DELAY_MS = 550
export const TOUCH_DRAG_TOLERANCE = 12
export const CONTEXT_MENU_DELAY_MS = 1000
